/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";
import {
  Row,
  Col,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton
} from "react-bootstrap";

import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import parseISO from "date-fns/parseISO";

import DropdownSearch from "../common/DropdownSearch";

import {
  formatDate,
  addMonthsToDate,
  addHoursToDate,
  addDaysToDate,
  startOfWeek,
  isSameOrAfter,
  isSameOrBefore,
  setMonth,
  setDate,
  setDay,
  addUnitsToDate
} from "../../helpers/date";

const weekdays = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
class RecurringCallForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { ...this.getInitialState() };
  }

  getInitialState = () => {
    const { recurrence, codes } = this.props;

    const initialState = !isEmpty(recurrence)
      ? {
          ...recurrence,
          canSubmit: false,
          days_of_week: recurrence.days_of_week?.map((d) =>
            weekdays.indexOf(d)
          ),
          interval: find(codes, {
            field: "recurrence",
            value: recurrence.interval
          }),
          dates: [
            isSameOrAfter(new Date(recurrence.start_date), new Date())
              ? new Date(recurrence.start_date)
              : formatDate(new Date(), "MM/dd/yyyy")
          ],
          start_date: isSameOrAfter(new Date(recurrence.start_date), new Date())
            ? new Date(recurrence.start_date)
            : new Date()
        }
      : {
          canSubmit: false,
          frequency: 1,
          interval: find(codes, {
            field: "recurrence",
            value: "day"
          }),
          days_of_week: [],
          notify: true,
          day_of_month: new Date(this.props.start_date).getDate(),
          monthOfYear: formatDate(new Date(), "LLLL"),
          dates: [formatDate(this.props.start_date, "MM/dd/yyyy")],
          actual_hrs: this.props.actual_hrs,
          start_date: new Date(this.props.start_date),
          end_date: addMonthsToDate(new Date(this.props.start_date), 3)
        };

    return initialState;
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  cancel = () => {
    this.props.onCancel();
  };

  save = (model) => {
    const {
      dates,
      days_of_week,
      frequency,
      interval,
      start_date,
      end_date,
      monthOfYear,
      day_of_month
    } = this.state;

    if (interval.label === "Yearly") {
      const recurrenceDate = setDate(
        setMonth(new Date(), monthOfYear.label),
        day_of_month
      );
      const year = new Date(recurrenceDate).getFullYear();

      if (isSameOrBefore(new Date(recurrenceDate), new Date(start_date))) {
        recurrenceDate.set("year", year + 1);
      }

      dates.push(formatDate(recurrenceDate, "MM/dd/yyyy"));
    }
    const daysPerWeek = days_of_week.length || 1;
    const formattedEndDate = new Date(end_date).setUTCHours(13);
    while (
      isSameOrBefore(
        addUnitsToDate(
          new Date(dates[dates.length - daysPerWeek]),
          frequency,
          interval.value
        ),
        new Date(formattedEndDate)
      )
    ) {
      let date = addUnitsToDate(
        new Date(dates[dates.length - 1]),
        frequency,
        interval.value
      );
      if (days_of_week.length) {
        days_of_week.forEach((day) => {
          date = formatDate(setDay(new Date(date), day), "MM/dd/yyyy");
          if (isSameOrBefore(new Date(date), new Date(formattedEndDate))) {
            dates.push(date);
          }
        });
      } else {
        dates.push(formatDate(new Date(date), "MM/dd/yyyy"));
      }
    }

    const daysOfWeek = days_of_week.length
      ? days_of_week
          .sort((a, b) => a - b)
          .map((day, i) =>
            i === 0
              ? formatDate(setDay(new Date(), day), "eeee")
              : ` ${formatDate(setDay(new Date(), day), "eeee")}`
          )
      : formatDate(new Date(start_date), "eeee");

    let summary = `Occurs `;

    if (frequency === 1 && interval.value === "day") {
      summary += "every day";
    } else if (frequency !== 1 && interval.value === "day") {
      summary += `every ${frequency} days`;
    }

    if (frequency === 1 && interval.value === "week") {
      summary += `every ${daysOfWeek}`;
    } else if (frequency !== 1 && interval.value === "week") {
      summary += `every ${frequency} weeks on ${daysOfWeek}`;
    }

    if (frequency === 1 && interval.value === "month") {
      summary += `day ${day_of_month} of every month`;
    } else if (frequency !== 1 && interval.value === "month") {
      summary += `day ${day_of_month} of every ${frequency} months`;
    }

    if (interval.value === "year") {
      summary += `every ${monthOfYear.label} ${day_of_month}`;
    }

    summary += ` effective ${formatDate(
      new Date(start_date),
      "MM/dd/yyyy"
    )} until ${formatDate(new Date(formattedEndDate), "MM/dd/yyyy")}`;

    const updatedModel = {
      ...model,
      days_of_week: days_of_week.map((d) => weekdays[d])
    };

    if (updatedModel.start_date) {
      updatedModel.start_date = parseISO(updatedModel.start_date);
    }
    if (updatedModel.end_date) {
      updatedModel.end_date = parseISO(updatedModel.end_date);
    }

    // remove any dates before the start date (needed for weekly option)
    const finalDates = dates.filter((date) =>
      isSameOrAfter(
        new Date(new Date(date).setUTCHours(14)),
        new Date(new Date(start_date).setUTCHours(13))
      )
    );

    this.props.onSubmit(updatedModel, finalDates, summary);
  };

  //  ------ SELECTORS ------------

  handleChange = (field, input) => {
    this.setState({ [field]: input });
    // Recurs: daily, weekly, etc. -> unit_of_time
    if (field === "interval") {
      this.setState(this.getInitialState(), () => {
        this.setState({ interval: input, days_of_week: [] });
      });
    }

    // "Every <input> [Days, Weeks, etc]"
    if (field === "frequency") {
      this.setState({ frequency: input });
    }

    // Duration
    if (field === "actual_hrs") {
      const actual_hrs = parseInt(input);
      this.setState({ actual_hrs, dates: [] });
      this.setState((prevState, props) => ({
        completed: addHoursToDate(
          prevState.arrived || props.arrived,
          actual_hrs
        )
      }));
    }

    if (field === "day_of_month") {
      const day_of_month = input ? parseInt(input) : 0;
      this.setState({ day_of_month, dates: this.state.dates });
    }
  };

  selectDate = (field, date) => {
    this.setState({ [field]: parseISO(date), dates: this.state.dates });
    if (this.state.interval?.value === "week") {
      this.handleToggle(this.state.days_of_week || []);
    }
  };

  // On: S M T W T F S  -> days_of_week
  handleToggle = (e) => {
    const startDate = formatDate(new Date(this.state.start_date), "MM/dd/yyyy");
    const firstWeek = formatDate(
      startOfWeek(new Date(startDate)),
      "MM/dd/yyyy"
    );

    const dates = e.map((day) =>
      formatDate(addDaysToDate(new Date(firstWeek), day), "MM/dd/yyyy")
    );
    this.setState({
      days_of_week: [...e],
      dates
    });
  };

  frequencyLabel = () => {
    const {
      interval: { label }
    } = this.state;

    if (label === "Daily") {
      return "day";
    }
    if (label === "Weekly") {
      return "week";
    }
    if (label === "Monthly") {
      return "month";
    }
    if (label === "Yearly") {
      return "year";
    }
  };

  render() {
    const { codes } = this.props;
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
    return (
      <div>
        <Formsy
          ref={(ref) => (this.form = ref)}
          className="vertical form"
          onValidSubmit={this.save}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <Row>
            <Col md={this.state.interval.label !== "Yearly" ? 9 : 12}>
              <DropdownSearch
                name="interval"
                label="Recurs:"
                value={this.state.interval.value}
                data={[
                  ...codes
                    .filter((code) => code.field === "recurrence")
                    .map((code) => ({
                      id: code.id,
                      value: code.value,
                      label: code.label
                    }))
                ]}
                onChange={this.handleChange}
              />
            </Col>
            {this.state.interval.label !== "Yearly" && (
              <Col md={3}>
                <Input
                  formNoValidate
                  type="number"
                  name="frequency"
                  label={`Every ${
                    this.state.frequency
                  } ${this.frequencyLabel()}(s)`}
                  value={this.state.frequency}
                  onChange={this.handleChange}
                />
              </Col>
            )}
            <Col md={5}>
              <Input
                disabled
                type="date"
                name="start_date"
                label="Between this Date:"
                onChange={this.selectDate}
                value={
                  this.state.start_date
                    ? formatDate(this.state.start_date, "yyyy-MM-dd")
                    : ""
                }
                validations={{
                  isValidDate(values, value) {
                    return value <= values.end_date;
                  }
                }}
                validationErrors={{
                  isValidDate: "Start date should be before end date"
                }}
              />
            </Col>
            <Col md={5}>
              <Input
                type="date"
                name="end_date"
                label="And this Date:"
                onChange={this.selectDate}
                value={
                  this.state.end_date
                    ? formatDate(this.state.end_date, "yyyy-MM-dd")
                    : ""
                }
                validations={{
                  isValidDate(values, value) {
                    return value >= values.start_date;
                  }
                }}
                validationErrors={{
                  isValidDate: "End date should be after start date"
                }}
              />
            </Col>
            <Col md={2}>
              <Checkbox
                formNoValidate
                name="notify"
                valueLabel="Notify on expiration"
                value={this.state.notify}
              />
            </Col>
          </Row>
          {this.state.interval.label !== "Weekly" && (
            <small>*excludes weekends</small>
          )}
          {this.state.interval.label === "Weekly" && (
            <Row>
              <Col md={12}>
                <ButtonToolbar>
                  <ToggleButtonGroup
                    type="checkbox"
                    onChange={this.handleToggle}
                    style={{ display: "flex" }}
                    value={[...this.state.days_of_week]}
                  >
                    {daysOfWeek.map((day, i) => (
                      <ToggleButton key={i} value={i + 1}>
                        {day.slice(0, 3)}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </ButtonToolbar>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              <input
                className="btn  btn-success"
                type="submit"
                disabled={!this.state.canSubmit}
                value="Save"
              />
            </Col>
          </Row>
        </Formsy>
      </div>
    );
  }
}

RecurringCallForm.propTypes = {
  recurrence: PropTypes.object,
  codes: PropTypes.array,
  start_date: PropTypes.string,
  actual_hrs: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    state: state.reducers
  };
}

export default connect(mapStatesToProps)(RecurringCallForm);
